<template>
    <div class="error-404 pt-[100px]">
        <div class="error-404-inner lg:w-full lg:h-[839px] h-[450px] flex flex-col justify-start items-center">
            <img src="/svg/errors/error-500.png" alt="Error 500" class="lg:w-[315px] w-[166px] mb-[80px]" />

            <h1 class="error-404-title lg:text-display-lg text-title-lg font-bold mb-6">Server Error</h1>

            <p
                class="text-gray-500 lg:text-title-sm !leading-7 text-body-md font-normal text-center px-4 lg:w-[854px] w-full"
            >
                The server encountered an internal error and was unable to complete request. Our tech wizards are
                working on the issue, please try again in a minute!
            </p>
            <app-button class="bg-brand-500 rounded-full text-gray-100 text-body-lg mt-6" @click="returnHomePage">
                Rejoin the Journey
            </app-button>
        </div>
    </div>
</template>

<script setup lang="ts">
// * components
const localePath = useLocalePath();
// * methods
const returnHomePage = () => {
    useRouter().push(localePath("/"));
};
</script>

<style lang="scss">
.error-404 {
    &-title {
        background: linear-gradient(360deg, rgba(77, 77, 189, 0.99) 0%, rgba(255, 255, 255, 0.83) 100%);
        background-clip: text;
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
    }
}
</style>
